import { onlyAlphabetsRegex } from 'Constants'
import { alphabetsWithSpace } from 'Constants/regex'
import { INestedQuestionSet } from 'Models/BOB/ResponseModels'

/* eslint-disable */

const educationalDetailsRenderObject: { form_fields: INestedQuestionSet[] } = {
  form_fields: [
    {
      max: undefined,
      name: 'Occupation',
      code: 'occupation',
      dropdown: {
        Professional: 'Professional',
        Salaried: 'Salaried',
        'Self Employed': 'Self Employed',
        Student: 'Student',
        Housewife: 'Housewife',
        Retired: 'Retired',
        Agriculturist: 'Agriculturist',
      },
      cover_type: 'dropdown',
      min: undefined,
      description: '',
      input_type: 'text',
      hidden: false,
      range: false,
      values: {
        Housewife: [
          {
            max: undefined,
            name: 'Parent/Husband Insurance Details(Sum Insured)',
            code: 'parent_husband_insurance_details',
            dropdown: {
              '2 Lakhs': 200000,
              '3 Lakhs': 300000,
              '5 Lakhs': 500000,
              '10 Lakhs': 1000000,
              '20 Lakhs': 2000000,
              '30 Lakhs': 3000000,
              '50 Lakhs': 5000000,
            },
            cover_type: 'dropdown',
            min: undefined,
            description: '',
            input_type: 'text',
            hidden: false,
            range: false,
            values: {},
          },
        ],
        Student: [
          {
            max: undefined,
            name: 'Parent/Husband Insurance Details(Sum Insured)',
            code: 'parent_husband_insurance_details',
            dropdown: {
              '2 Lakhs': 200000,
              '3 Lakhs': 300000,
              '5 Lakhs': 500000,
              '10 Lakhs': 1000000,
              '20 Lakhs': 2000000,
              '30 Lakhs': 3000000,
              '50 Lakhs': 5000000,
            },
            cover_type: 'dropdown',
            min: undefined,
            description: '',
            input_type: 'text',
            hidden: false,
            range: false,
            values: {},
          },
        ],
      },
    },
    {
      max: undefined,
      name: 'Industry Type',
      code: 'industry_type',
      dropdown: {
        Jewellery: 'Jewellery',
        'Import/Export': 'Import/Export',
        Mining: 'Mining',
        Shipping: 'Shipping',
        'Scrap Dealing': 'Scrap Dealing',
        'Real Estate': 'Real Estate',
        Agriculture: 'Agriculture',
        'Stock Broking': 'Stock Broking',
        Others: 'Others',
      },
      cover_type: 'dropdown',
      min: undefined,
      description: '',
      input_type: 'text',
      hidden: false,
      range: false,
      values: {
        Others: [
          {
            max: undefined,
            name: 'Other Industry Type',
            code: 'others_industry_type',
            dropdown: {},
            cover_type: 'dropdown',
            min: undefined,
            description: '',
            input_type: 'text',
            hidden: false,
            range: false,
            values: {},
            // required: true,
          },
        ],
      },
    },

    {
      max: undefined,
      name: 'Organization Type',
      code: 'organization_type',
      dropdown: {},
      cover_type: 'dropdown',
      min: undefined,
      description: '',
      input_type: 'text',
      hidden: false,
      range: false,
      values: {},
    },
    {
      max: 9999999999,
      name: 'Annual Income',
      code: 'annual_income',
      dropdown: undefined,
      cover_type: 'Text',
      min: 1,
      description: '',
      input_type: 'Numeric',
      regex: '',
      hidden: false,
      range: false,
      values: {},
    },
    {
      max: undefined,
      name: 'My Hobby or Work does not involve me to do any Hazardous work.',
      code: 'nature_of_work',
      dropdown: {
        // Yes: 'My Hobby or Work does not involve me to do any Hazardous work',
        // No: 'My Hobby or Work involves me to do Hazardous work.',
        No: 'Involves Hazardous Activity',
        Yes: 'No Hazardous Activity',
      },
      cover_type: 'switch',
      min: undefined,
      description: '',
      input_type: 'String',
      hidden: false,
      range: false,
      values: {},
      regex: '',
    },
    {
      max: undefined,
      name: 'Source of Income',
      code: 'source_of_income',
      dropdown: undefined,
      cover_type: 'Text',
      min: undefined,
      description: '',
      input_type: 'String',
      hidden: false,
      range: false,
      values: {},
      regex: /^(?! )(?!.*\s.*\s)[A-Za-z ]{2,40}$/,
    },
    {
      max: undefined,
      name: 'Educational Qualification',
      code: 'qualifications',
      dropdown: {},
      cover_type: 'dropdown',
      min: undefined,
      description: '',
      input_type: 'text',
      hidden: false,
      range: false,
      values: {},
    },
    // {
    //   max: undefined,
    //   name: 'Is Existing Policy Holder?',
    //   code: 'isExistingPolicyHolder',
    //   dropdown: { Yes: 'Yes', No: 'No' },
    //   cover_type: 'switch',
    //   min: undefined,
    //   description: 'Choose One of ',
    //   input_type: 'text',
    //   hidden: false,
    //   values: {},
    // },
    {
      max: undefined,
      name: 'Is Politically Exposed?',
      code: 'is_politically_exposed',
      dropdown: { True: 'True', False: 'False' },
      cover_type: 'switch',
      min: undefined,
      description: '',
      input_type: 'text',
      hidden: false,
      values: {
        True: [
          {
            max: 50,
            name: 'Politically Exposed Description',
            code: 'politicallyExposedDescription',
            dropdown: undefined,
            cover_type: 'Text',
            min: 2,
            description: '',
            input_type: 'String',
            hidden: false,
            range: false,
            values: {},
          },
        ],
        False: [],
      },
    },
  ],
}

const vernacularDeclarationString =
  'I hereby confirm that I have been explained the contents in (language) and have understood the same.'

const illitrateDeclarationString =
  'I hereby confirm that I have been explained the contents in (language) and have understood the same and that the proposer has affixed the thumb impression above after fully understanding the contents thereof.'

const vernacularAndIllitrateFormObject: { form_fields: INestedQuestionSet[] } = {
  form_fields: [
    {
      max: 30,
      name: 'Name of Declarant',
      code: 'nameOfDeclarant',
      dropdown: {},
      cover_type: 'Text',
      min: 1,
      description: '',
      input_type: 'String',
      hidden: false,
      values: {},
    },
    {
      max: undefined,
      name: 'Mobile number',
      code: 'mobileNo',
      dropdown: {},
      cover_type: 'Text',
      min: undefined,
      description: '',
      input_type: 'String',
      regex: '^[6789][0-9]{9}$',
      hidden: false,
      values: {},
    },
    {
      max: undefined,
      name: 'Relationship',
      code: 'relationWithLAOrPR',
      dropdown: {
        Father: 'Father',
        Mother: 'Mother',
      },
      cover_type: 'dropdown',
      min: undefined,
      description: '',
      input_type: 'String',
      hidden: false,
      values: {},
    },
    {
      max: 30,
      name: 'Address',
      code: 'address',
      dropdown: {},
      cover_type: 'Text',
      min: 1,
      description: '',
      input_type: 'String',
      hidden: false,
      values: {},
    },
    {
      name: 'Pincode',
      code: 'pincode',
      dropdown: {},
      cover_type: 'Text',
      max: 6,
      min: 6,
      regex: '^[0-9]{6}$',
      description: '',
      input_type: 'String',
      hidden: false,
      values: {},
    },
    {
      max: undefined,
      name: 'City',
      code: 'city',
      dropdown: undefined,
      cover_type: 'Text',
      min: undefined,
      description: '',
      input_type: 'text',
      hidden: false,
      range: false,
      values: {},
    },
    {
      max: undefined,
      name: 'State',
      code: 'state',
      dropdown: undefined,
      cover_type: 'Text',
      min: undefined,
      description: '',
      input_type: 'text',
      hidden: false,
      range: false,
      values: {},
    },
  ],
}

export {
  educationalDetailsRenderObject,
  vernacularDeclarationString,
  illitrateDeclarationString,
  vernacularAndIllitrateFormObject,
}
